import { webTypeApiUrl } from "@/constants/webTypeApiUrl";


export const MobileHomeHandler = {
  GetTutorChatTokenModel: function (tutorChatToken) {
    var tutorChatTokenModel_ = [];
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/SCRMApp/GetTutorChatTokenModel",
      type: "post",
      cache: false,
      async: false,
      data: {
        tutorChatToken: tutorChatToken,
      },
      dataType: "json",
      success: function (data) {
        tutorChatTokenModel_ = data.Result;
      },
      error: function (a, b, c) {
        //window.location.href = "/#/Error";
      }
    });
    return tutorChatTokenModel_;
  },
  GetMobileHomeInfo: function (tutorChatToken) {
    var mobileHomeInfo_ = [];
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/SCRMApp/GetMobileHomeInfo",
      type: "post",
      cache: false,
      async: false,
      data: {
        tutorChatToken: tutorChatToken,
      },
      dataType: "json",
      success: function (data) {
        mobileHomeInfo_ = data;
      },
      error: function (a, b, c) {
        //window.location.href = "/#/Error";
      }
    });
    return mobileHomeInfo_;
  },
  GetSalseQRCodeURL: function (tutorChatToken) {
    var salseQRCode_ = [];
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/SCRMApp/GetSalseQRCodeURL",
      type: "post",
      cache: false,
      async: false,
      data: {
        tutorChatToken: tutorChatToken,
      },
      dataType: "json",
      success: function (data) {
        salseQRCode_ = data.Result;
      },
      error: function (a, b, c) {
        //window.location.href = "/#/Error";
      }
    });
    return salseQRCode_;
  },
};



// WEBPACK FOOTER //
// ./src/handler/MobileHomeHandler.js